<template>
  <div class="custom-page-card custom-page-card--skeleton">
    <div class="custom-page-card__container">
      <div class="custom-page-card__actions">
        <SkeletonRow />
        <SkeletonRow />
      </div>
      <div class="custom-page-card__content">
        <div class="custom-page-card__image">
          <div class="custom-page-card__no-image">
            <SkeletonRow />
          </div>
        </div>
        <ul class="custom-page-card__props">
          <li class="custom-page-card__prop">
            <span class="custom-page-card__prop--label">
              <SkeletonRow />
            </span>
            <span class="custom-page-card__prop--value">
              <SkeletonRow />
            </span>
          </li>
          <li class="custom-page-card__prop">
            <span class="custom-page-card__prop--label">
              <SkeletonRow />
            </span>
            <span class="custom-page-card__prop--value">
              <SkeletonRow />
            </span>
          </li>
        </ul>
      </div>
      <div class="custom-page-card__footer">
        <SkeletonRow />
        <SkeletonRow />
      </div>
    </div>
  </div>
</template>
<script>
import SkeletonRow from '@/components/custom/skeleton/skeletonRow.vue'
export default {
  components: {
    SkeletonRow,
  },
}
</script>
<style lang="scss" src="./style.module.scss" />
